import { Checkbox, FormControlLabel, Grid2 } from "@mui/material";
import { Moment } from "moment";
import { FC, useEffect, useState } from "react";
import {
	EndFilter,
	StartFilter,
} from "../../../shared/components/StartEndFilter";

type Props = {
	onFilterChange: (startDate: Moment, endDate: Moment) => void;
	initialStartDate: Moment;
	initialEndDate: Moment;
	selectedDelayArea: number | null;
	onDelayAreaChange: (assetId: number | null) => void;
	includeUndeclaredDelays: boolean;
	onIncludeUndeclaredDelaysChange: (include: boolean) => void;
};

export const Filters: FC<Props> = ({
	onFilterChange,
	initialStartDate,
	initialEndDate,
	selectedDelayArea,
	onDelayAreaChange,
	includeUndeclaredDelays,
	onIncludeUndeclaredDelaysChange,
}) => {
	const [startDate, setStartDate] = useState<Moment>(initialStartDate);
	const [endDate, setEndDate] = useState<Moment>(initialEndDate);

	useEffect(() => {
		setStartDate(initialStartDate);
		setEndDate(initialEndDate);
	}, [initialStartDate, initialEndDate]);

	const handleStartDateChange = (date: Moment | null) => {
		if (date) {
			setStartDate(date);
			onFilterChange(date, endDate);
		}
	};

	const handleEndDateChange = (date: Moment | null) => {
		if (date) {
			setEndDate(date);
			onFilterChange(startDate, date);
		}
	};

	return (
		<Grid2 container alignItems="center" spacing={2}>
			<Grid2 size={{ xs: 12, md: 1.5 }}>
				<StartFilter
					value={startDate}
					onChange={handleStartDateChange}
					maxDate={endDate}
				/>
			</Grid2>
			<Grid2 size={{ xs: 12, md: 1.5 }}>
				<EndFilter
					value={endDate}
					onChange={handleEndDateChange}
					minDate={startDate}
				/>
			</Grid2>
			{/* <Grid2 size={{xs:12}} size={{md: 2}}>
        <DelayAreaFilter
          value={selectedDelayArea}
          onChange={onDelayAreaChange}
        />
      </Grid2> */}
			<Grid2 size={{ xs: 12, md: 2 }}>
				<FormControlLabel
					control={
						<Checkbox
							checked={includeUndeclaredDelays}
							color="primary"
							onChange={(e) =>
								onIncludeUndeclaredDelaysChange(e.target.checked)
							}
						/>
					}
					label="Undeclared"
				/>
			</Grid2>
		</Grid2>
	);
};
